const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisLogoColorNegative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 764 289",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M217.44,89.43c5.41,0.09 6.94,-3.55 4.52,-8.57c-2.42,-5.02 -8.3,-9.14 -13.54,-9.28c-5.25,-0.14 -7.58,3.27 -5.17,8.22c2.4,4.94 8.78,9.55 14.19,9.63",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,150.72c-0.28,6.66 0.49,12.06 2.36,11.73c1.87,-0.32 4.14,-5.7 4.61,-11.68c0.47,-5.98 -1.23,-10.87 -3.25,-11.19c-2.02,-0.33 -3.44,4.48 -3.72,11.14",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,219.32c4.12,-3.21 8.07,-8.67 9.23,-12.45c1.16,-3.78 -0.97,-4.12 -5.19,-0.45c-4.23,3.67 -8.8,9.52 -9.86,12.84c-1.06,3.32 1.7,3.27 5.82,0.06",
    style: {
      fill: "#008ecf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.97,125.14c1.82,6.24 3.86,8.64 4.93,5.67c1.07,-2.98 0.73,-9.72 -1.17,-15.37c-1.9,-5.66 -4.56,-8.47 -5.56,-6.07c-1,2.38 -0.03,9.52 1.8,15.77",
    style: {
      fill: "#3aaa35",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.97,188.94c2.74,-5.35 3.91,-11.51 3.07,-13.7c-0.84,-2.19 -3.67,1 -6.71,6.99c-3.04,5.99 -4.87,11.92 -3.73,13.47c1.15,1.55 4.63,-1.41 7.37,-6.76",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.78,146.79c-1.49,7.81 3.73,14.43 11.66,15.56c7.93,1.12 15.72,-4.03 17.42,-12.37c1.7,-8.34 -4.08,-16.29 -12.1,-16.95c-8.01,-0.66 -15.49,5.95 -16.98,13.76",
    style: {
      fill: "#3aaa35",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.55,96.04c4.92,-2.9 4.54,-9.19 -0.56,-13.76c-5.1,-4.57 -12.79,-6.1 -17.52,-3.7c-4.73,2.4 -4.85,8.18 0.05,13.25c4.9,5.07 13.11,7.11 18.03,4.21",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,190.86c1.98,4.55 8.7,7.23 15.28,6.05c6.59,-1.18 10.66,-6.21 8.85,-11.3c-1.81,-5.09 -8.97,-7.84 -15.73,-6.11c-6.75,1.72 -10.38,6.81 -8.4,11.36",
    style: {
      fill: "#3aaa35",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,116.53c2.99,-5.46 0.08,-12.06 -6.13,-15.06c-6.22,-3 -13.37,-1.66 -16.33,3.23c-2.96,4.9 -0.63,11.95 5.56,15.51c6.18,3.56 13.91,1.78 16.9,-3.68",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.11,217.6c4.12,2.92 11.52,3.36 16.85,0.66c5.33,-2.71 6.58,-7.85 2.43,-11.1c-4.14,-3.24 -12.12,-3.07 -17.43,-0.04c-5.29,3.03 -5.96,7.56 -1.85,10.48",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,98.68c3.41,3.99 5.63,2.98 5.16,-1.64c-0.47,-4.62 -3.56,-10.94 -7.08,-14.63c-3.51,-3.68 -6,-3.56 -5.43,0.76c0.58,4.32 3.93,11.53 7.35,15.51",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.15,225.48c3.88,-0.64 9,-3.67 11.7,-7.16c2.7,-3.5 1.99,-6.13 -1.95,-5.41c-3.94,0.72 -9.98,3.59 -12.56,7.14c-2.57,3.55 -1.07,6.07 2.81,5.43",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.02,238.76c5.97,1.96 15.64,1.5 22.07,-1.36c6.43,-2.86 6.89,-7.5 0.37,-9.84c-6.52,-2.33 -17.18,-1.17 -23.07,2.06c-5.89,3.25 -5.35,7.18 0.63,9.14",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.99,69.4c4.49,2.97 5.72,1.41 3.17,-2.84c-2.55,-4.25 -8.24,-9.44 -12.93,-11.99c-4.69,-2.55 -6.44,-1.91 -3.69,1.92c2.76,3.83 8.96,9.94 13.45,12.91",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,113.47c-2.71,8.18 2.69,17.94 13.1,20.87c10.4,2.93 21.85,-3.1 24.43,-12.3c2.58,-9.2 -4.5,-17.32 -14.77,-19.22c-10.27,-1.89 -20.05,2.48 -22.76,10.65",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,242.37c6.45,-2.14 13.65,-6.91 16.72,-10.8c3.07,-3.88 1.26,-5.1 -4.88,-2.4c-6.15,2.7 -14.43,7.75 -17.81,11.08c-3.38,3.32 -0.48,4.26 5.97,2.12",
    style: {
      fill: "#008ecf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,68.42c6.43,-1.79 5.86,-7.08 -0.44,-11.23c-6.3,-4.15 -15.37,-6.07 -21.11,-4.71c-5.75,1.36 -6.62,5.73 -1,10.32c5.62,4.57 16.12,7.41 22.55,5.62",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.31,174.53c1.76,8.3 10.79,14.01 20.97,13.32c10.17,-0.69 17.98,-8.32 16.64,-17.92c-1.34,-9.59 -11.67,-16.36 -22.26,-14.39c-10.6,1.99 -17.11,10.69 -15.35,18.99",
    style: {
      fill: "#3aaa35",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,86.57c5.06,-5.12 1.44,-12.1 -6.85,-15.6c-8.29,-3.5 -18.13,-2.83 -23.17,1.41c-5.03,4.25 -3.29,11.03 4.96,15.41c8.27,4.38 20,3.9 25.06,-1.22",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5,218.19c4.74,4.15 14.41,5.89 22.72,3.9c8.31,-1.99 11.94,-7.52 7.01,-12.32c-4.93,-4.8 -16.45,-6.36 -24.57,-3.72c-8.12,2.64 -9.9,7.99 -5.16,12.14",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.49,243.35c6.04,4.25 16.83,4.63 26.71,1.83c9.89,-2.8 13.78,-8.19 6.08,-12.8c-7.7,-4.61 -22.91,-6 -31.13,-2.85c-8.22,3.16 -7.7,9.57 -1.66,13.82",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.88,73.53c-6.31,6.37 -3.78,14.25 7.42,18.08c11.21,3.83 27.37,0.5 33.5,-7.4c6.13,-7.9 0.05,-15.95 -10.99,-18.25c-11.04,-2.31 -23.62,1.2 -29.93,7.57",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,257.48c8.41,0.21 21.27,-3.16 28.57,-6.9c7.31,-3.74 6.97,-6.18 -1.5,-5.76c-8.47,0.42 -22.18,2.13 -29.29,5.49c-7.09,3.37 -6.19,6.96 2.22,7.17",
    style: {
      fill: "#008ecf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.01,45.68c7.87,-0.56 7.15,-3.5 0.19,-7.33c-6.96,-3.83 -16.9,-6.77 -22.94,-6.68c-6.04,0.09 -7.6,3.46 -2.3,7.46c5.3,3.99 17.18,7.1 25.05,6.55",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.65,144.71c-0.21,9.94 8.4,18.34 21.01,20.3c12.61,1.97 24.91,-4.46 25.46,-16.64c0.56,-12.17 -11.04,-23.99 -24.07,-23.83c-13.02,0.16 -22.19,10.23 -22.4,20.17",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.17,55.97c7.85,-3.62 4.99,-9.91 -2.91,-13.91c-7.89,-4 -17.27,-4.48 -24.55,-1.15c-7.29,3.33 -9.89,9.01 -2.58,13.3c7.31,4.27 22.19,5.37 30.04,1.76",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.24,203.13c5.63,7.06 16.71,12.12 27.63,11.57c10.93,-0.54 17.87,-6.87 12.44,-14.82c-5.43,-7.95 -21.27,-13.38 -32.37,-11.96c-11.1,1.43 -13.33,8.15 -7.7,15.21",
    style: {
      fill: "#3aaa35",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.62,35.98c2.53,-1.15 2.07,-2.97 -0.54,-4.22c-2.61,-1.25 -6.12,-1.52 -8.35,-0.42c-2.23,1.1 -2.6,3.19 -0.29,4.49c2.3,1.29 6.64,1.3 9.18,0.15",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.42,176.88c1.31,3.1 5.34,5.9 9.37,6.31c4.03,0.41 6.59,-1.89 5.32,-5.21c-1.27,-3.33 -5.93,-6.23 -10,-6.42c-4.07,-0.17 -6,2.22 -4.69,5.32",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.03,102.49c-1.39,3.61 0.56,7.35 4.79,8.23c4.23,0.88 9.31,-1.77 10.87,-5.73c1.57,-3.97 -1.08,-7.48 -5.48,-8c-4.4,-0.52 -8.79,1.88 -10.18,5.5",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88,228.54c2.38,2.48 6.07,3.77 8.88,2.99c2.81,-0.78 3.59,-3.28 1.08,-5.71c-2.51,-2.42 -7.23,-3.86 -9.92,-3.14c-2.69,0.73 -2.42,3.38 -0.04,5.86",
    style: {
      fill: "#49648c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,50.93c-3.23,2.33 -3.66,4.66 -0.5,5.32c3.15,0.66 8.66,-0.63 11.78,-2.98c3.13,-2.35 2.74,-4.82 -0.31,-5.46c-3.05,-0.64 -7.75,0.79 -10.97,3.12",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,245.57c2.48,0.75 6.82,0.43 9.82,-0.65c3,-1.07 3.37,-2.57 0.69,-3.38c-2.68,-0.82 -7.25,-0.59 -10.04,0.56c-2.8,1.14 -2.95,2.73 -0.47,3.47",
    style: {
      fill: "#008ecf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.45,48.96c2.69,1.03 3.33,0.52 1.53,-1.12c-1.8,-1.64 -5.41,-3.71 -8.14,-4.61c-2.73,-0.9 -3.52,-0.41 -1.68,1.1c1.84,1.52 5.59,3.6 8.29,4.63",
    style: {
      fill: "#86bc25",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.85,110.85c-1.28,3.62 1.03,7.5 5.45,8.5c4.41,1 9.33,-1.48 10.64,-5.35c1.31,-3.86 -1.47,-7.46 -5.93,-8.21c-4.46,-0.75 -8.89,1.44 -10.16,5.06",
    style: {
      fill: "#afca0b",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.38,199.93l-12.84,32.1l5.19,0l2.9,-7.65l14.42,0l2.9,7.65l5.32,0l-12.79,-32.1l-5.1,0Zm-3.12,20.09l4.83,-12.49l0.62,-2.2l0.26,0l0.62,2.2l4.83,12.49l-11.16,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.32,
    y: 199.93,
    width: 4.84,
    height: 32.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.04,204.41l9.59,0l0,27.61l4.83,0l0,-27.61l9.59,0l0,-4.48l-24.01,0l0,4.48Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,199.27c-9.28,0 -14.29,5.06 -14.29,16.71c0,11.65 5.01,16.71 14.29,16.71c9.23,0 14.29,-5.06 14.29,-16.71c0,-11.66 -5.06,-16.71 -14.29,-16.71Zm-0.44,28.93c-5.06,-0 -7.78,-2.33 -7.78,-2.33c0,-0 -1.1,-3.08 -1.1,-9.89c0,-9.06 3.12,-12.23 9.76,-12.23c5.1,-0 7.78,2.33 7.78,2.33c0,-0 1.1,3.12 1.1,9.89c0,9.11 -3.12,12.23 -9.76,12.23Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.88,232.02l20.71,0l0,-4.48l-15.87,-0l0,-9.76l14.11,-0l0,-4.49l-14.11,-0l0,-8.88l15.87,-0l0,-4.48l-20.71,-0l0,32.09Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.35,212.28l-0.97,2.2l-0.26,0l-0.97,-2.2l-7.96,-12.35l-5.32,0l0,0.44l11.87,17.98l0,13.67l4.84,0l0,-13.67l11.87,-17.98l0,-0.44l-5.14,0l-7.96,12.35Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.66,204.41l0,-4.48l-20.71,0l0,32.09l20.71,0l0,-4.48l-15.87,-0l0,-9.76l14.11,-0l0,-4.49l-14.11,-0l0,-8.88l15.87,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.02,167.83l32.15,0l1.64,-8.53l-22.97,0l2.3,-11.81l20.34,0l1.7,-8.53l-20.33,0l2.03,-10.5l22.96,0l1.64,-8.53l-32.15,0l-9.31,47.9Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.07,128.46l13.78,0l-7.68,39.37l9.19,0l7.68,-39.37l13.77,0l1.65,-8.53l-36.75,0l-1.64,8.53Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.8,151.76l0,3.27l-0.66,0l-0.65,-3.27l-14.5,-31.83l-9.84,0l-9.25,47.9l9.18,0l6.17,-31.82l-0,-3.28l0.65,0l0.66,3.28l14.5,31.82l9.84,0l9.25,-47.9l-9.18,0l-6.17,31.83Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.5,167.83l9.19,0l9.31,-47.9l-9.18,0l-9.32,47.9Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.69,127.48c8.53,0 14.5,2.95 14.5,2.95l1.64,-8.53c0,0 -4.26,-2.95 -14.76,-2.95c-18.77,0 -27.49,13.19 -27.49,31.88c0,11.75 6.36,17.98 17.65,17.98c13.12,0 19.88,-5.58 19.88,-5.58l4.33,-22.31l-17.06,0l-1.71,8.53l8.2,0l-1.64,8.53c0,0 -3.41,2.29 -9.97,2.29c-7.87,0 -11.09,-3.61 -11.09,-3.61c0,-0.13 0.13,-3.94 1.84,-12.79c2.62,-13.44 6.16,-16.39 15.68,-16.39Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.5,138.63l-21.98,0l3.67,-18.7l-9.18,0l-9.32,47.9l9.18,0l4.01,-20.67l21.98,0l-4.01,20.67l9.19,0l9.32,-47.9l-9.19,0l-3.67,18.7Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.25,119.93l-1.64,8.53l13.78,0l-7.68,39.37l9.19,0l7.68,-39.37l13.77,0l1.64,-8.53l-36.74,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.34,106.54l-23.57,0l-11.92,61.29l9.92,0l4.46,-22.75l12.21,0l8.23,22.75l11.03,0l-9.24,-23.76l1.54,-0.28c0.69,-0.13 16.79,-3.31 16.79,-21.65c0,-9.91 -7.09,-15.6 -19.45,-15.6Zm-5.16,29.76l-14.27,0l4.1,-20.97l22.25,0l0.39,0.47c0.08,0.1 1.96,2.42 1.96,6.86c-0.01,8.79 -5.13,13.64 -14.43,13.64Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.31,167.83l9.82,0l11.92,-61.29l-9.84,-0l-11.9,61.29Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.37,123.98c0,10.09 9.23,13.24 17.37,16.02c6.39,2.18 12.42,4.24 12.42,9.58c0,7.04 -4.97,10.47 -15.19,10.47c-9.62,0 -17.47,-3.36 -20.73,-5l-1.85,9.6c2.07,1.13 8.7,4.16 20.31,4.16c18.5,0 27.88,-6.97 27.88,-20.72c0,-10.09 -9.26,-13.24 -17.43,-16.02c-6.4,-2.18 -12.45,-4.24 -12.45,-9.58c0,-3.98 2.29,-8.72 13.18,-8.72c8.88,0 16.17,2.31 19.21,3.44l1.71,-8.87c-2.01,-0.96 -8.05,-3.33 -18.73,-3.33c-16.81,0 -25.7,6.56 -25.7,18.97Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisLogoColorNegative);
export default __webpack_public_path__ + "static/media/ris_logo_color_negative.a59dce398fe45af54333f36769066c2a.svg";
export { ForwardRef as ReactComponent };